<template>
  <div class="sidebar-inner" style="width: 100%;">
    <div class="condition-banner">
      Purchased or Activated
    </div>
    <form @submit.prevent>
      <div class="form-group">
        <div class="row">
          <div class="col-xs-2">
            <span class="icon icon-radio-unchecked" v-if="purchase_activated !== 'purchase'" @click="purchase_activated = 'purchase'"></span>
            <span class="icon icon-radio-checked" v-if="purchase_activated === 'purchase'" @click="purchase_activated = 'purchase'"></span>
          </div>
          <div class="col-xs-10">
            <label @click="purchase_activated = 'purchase'">
              Purchase Only
            </label>
            <small class="form-text text-muted">
              This will only look for the event purchased
            </small>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="row">
          <div class="col-xs-2">
            <span class="icon icon-radio-unchecked" v-if="purchase_activated !== 'activation'" @click="purchase_activated = 'activation'"></span>
            <span class="icon icon-radio-checked" v-if="purchase_activated === 'activation'" @click="purchase_activated = 'activation'"></span>
          </div>
          <div class="col-xs-10">
            <label @click="purchase_activated = 'activation'">
              Purchased and Activated
            </label>
            <small class="form-text text-muted">This will look for all contacts who have purchased and then visited using the same pricing option</small>
          </div>
        </div>
      </div>
    </form>

    <div class="condition-banner">
      Purchase Details
    </div>

    <form @submit.prevent>
      <div class="form-group">
        <div class="row">
          <div class="col-xs-2">
            <span class="icon icon-radio-unchecked" v-if="purchase_type === null || purchase_type != 'any'" @click="purchase_type = 'any'"></span>
            <span class="icon icon-radio-checked" v-if="purchase_type === 'any'" @click="purchase_type = 'any'"></span>
          </div>
          <div class="col-xs-10">
            <label for="purchase_type_any" @click="purchase_type = 'any'">
              First Purchase was any Pricing Option
            </label>
            <small class="form-text text-muted">Isolates the first time a client purchases this specific type of purchase</small>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="row">
          <div class="col-xs-2">
            <span class="icon icon-radio-unchecked" v-if="purchase_type === null || purchase_type != 'specific'" @click="purchase_type = 'specific'"></span>
            <span class="icon icon-radio-checked" v-if="purchase_type === 'specific'" @click="purchase_type = 'specific'"></span>
          </div>
          <div class="col-xs-10">
            <label for="purchase_type_specific" @click="purchase_type = 'specific'">
               First Purchase was a specific Pricing Option
            </label>
            <small class="form-text text-muted">Isolates the first time a client purchases this specific type of purchase</small>
          </div>
        </div>
      </div>

      <div class="options-inner" v-if="purchase_type === 'specific'">
        <div class="form-group">
          <label for="pricing_options">Pricing Option(s)</label>
          <div class="multiselect-block">
            <Multiselect v-model="selected_pricing_options" placeholder="Select Pricing Option(s)" :options="pricing_options" label="name" track-by="id" :searchable="true" :allow-empty="true" :show-labels="false" :multiple="true" :close-on-select="false" />
          </div>
        </div>
      </div>
    </form>

    <div class="condition-banner">
      Time Frame
    </div>

    <form @submit.prevent>
      <div class="form-group">
        <div class="row">
          <div class="col-xs-2">
            <span class="icon icon-radio-unchecked" v-if="timeframe === null || timeframe !== 'absolute'" @click="timeframe = 'absolute'; comparison = null;"></span>
            <span class="icon icon-radio-checked" v-if="timeframe === 'absolute'" @click="timeframe = 'absolute'; comparison = null;"></span>
          </div>
          <div class="col-xs-10">
            <label for="timeframe_absolute" @click="timeframe = 'absolute'; comparison = null;">
              First Purchase happened around specific dates
            </label>
            <small class="form-text text-muted">Isolates the first time a client purchases this specific type of purchase during the timeframe</small>
          </div>
        </div>
      </div>

      <div class="options-inner" v-if="timeframe === 'absolute'">
        <div class="form-group">
          <label>These purchases occured </label>
          <Multiselect v-model="comparison" placeholder="Select a comparison" :options="comparisons_date" label="label" track-by="value" :searchable="false" :allow-empty="false" :show-labels="false" />
        </div>
        <div class="dates" v-if="comparison && timeframe === 'absolute'">
          <div class="date">
            <vue-datepicker-local v-model="dates.start" :local="local" format="MM-DD-YYYY" />
          </div>
          <span v-if="comparison.value === 'between'">&nbsp;and&nbsp;</span>
          <div class="date" v-if="comparison.value === 'between'">
            <vue-datepicker-local v-model="dates.end" :local="local" format="MM-DD-YYYY" />
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="row">
          <div class="col-xs-2">
            <span class="icon icon-radio-unchecked" v-if="timeframe === null || timeframe !== 'relative'" @click="timeframe = 'relative'; comparison = null;"></span>
            <span class="icon icon-radio-checked" v-if="timeframe === 'relative'" @click="timeframe = 'relative'; comparison = null;"></span>
          </div>
          <div class="col-xs-10">
            <label for="timeframe_relative" @click="timeframe = 'relative'; comparison = null;">
              First Purchase happened relative to the current date
            </label>
            <small class="form-text text-muted">Isolates the first time a client purchases this specific type of purchase.</small>
          </div>
        </div>
      </div>

      <div class="options-inner" v-if="timeframe === 'relative'">
        <div class="form-group">
          Every contact who made a purchase
          <Multiselect v-model="comparison" placeholder="Select a comparison" :options="comparisons_number" label="label" track-by="value" :searchable="false" :allow-empty="false" :show-labels="false" />
          <input type="number" name="relative_days" v-model.number="relative_days" class="form-control" min="0" style="display: inline-block; width: 5rem;" />
          days<span v-if="comparison && comparison.value !== 'within'"> ago</span>.
        </div>
      </div>

      <div class="form-group">
        <div class="row">
          <div class="col-xs-2">
            <span class="icon icon-radio-unchecked" v-if="timeframe === null || timeframe !== 'all'" @click="timeframe = 'all'; comparison = null;"></span>
            <span class="icon icon-radio-checked" v-if="timeframe === 'all'" @click="timeframe = 'all'; comparison = null;"></span>
          </div>
          <div class="col-xs-10">
            <label for="timeframe_all" @click="timeframe = 'all'; comparison = null;">
              All time
            </label>
            <small class="form-text text-muted">Isolates the first time a client purchases this specific type of purchase.</small>
          </div>
        </div>
      </div>
    </form>

    <div class="condition-banner">
      Location and Site ID (Optional)
    </div>

    <form @submit.prevent>
      <div class="form-group">
        <div class="row">
          <div class="col-xs-2">
            <span class="icon icon-radio-unchecked" v-if="misc_filtering === null || misc_filtering === true" @click="misc_filtering = false"></span>
            <span class="icon icon-radio-checked" v-if="misc_filtering === false" @click="misc_filtering = false"></span>
          </div>
          <div class="col-xs-10">
            <label for="misc_filtering_no" @click="misc_filtering = false">
              Select all locations and Site IDs
            </label>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="row">
          <div class="col-xs-2">
            <span class="icon icon-radio-unchecked" v-if="misc_filtering === null || misc_filtering === false" @click="misc_filtering = true"></span>
            <span class="icon icon-radio-checked" v-if="misc_filtering === true" @click="misc_filtering = true"></span>
          </div>
          <div class="col-xs-10">
            <label for="misc_filtering_yes" @click="misc_filtering = true">
               Select specific locations or Site IDs
            </label>
          </div>
        </div>
      </div>
      <div class="options-inner" v-if="misc_filtering">
        <div class="form-group">
          <label class="form-control-label">Location</label>
          <div class="multiselect-block">
            <Multiselect v-model="location" placeholder="All Locations" label="location_name" track-by="location_id" :options="locations" :searchable="false" :allow-empty="true" :show-labels="false" :close-on-select="false" />
          </div>
        </div>
      </div>
    </form>

    <form @submit.prevent>
      <div class="form-group">
        <button type="button" class="xpl-button xpl-button--primary" @click.stop="commitCondition">Save this condition</button>
      </div>
    </form>
  </div>
</template>
<script>
  import EventBus from '@/event-bus';
  import * as api from '@/api';
  import Multiselect from 'vue-multiselect';
  import VueDatepickerLocal from 'vue-datepicker-local';

  export default {
    props: ['locations', 'condition', 'editedRule'],
    data() {
      return {
        edit_state: false,
        see_more: false,
        purchase_activated: null,
        purchase_type: null,
        purchased_nothing_before: false,
        purchased_this_before: false,
        timeframe: 'all',
        comparison: null,
        relative_days: 0,
        misc_filtering: false,
        location: null,
        comparisons_date: [{
          label: 'After',
          value: 'after',
        }, {
          label: 'Before',
          value: 'before',
        }, {
          label: 'Between',
          value: 'between',
        }],
        comparisons_number: [{
          label: 'At least',
          value: 'more',
        }, {
          label: 'Within the last',
          value: 'within',
        }, {
          label: 'Exactly',
          value: 'exactly',
        }],
        dates: {
          start: '',
          end: '',
        },
        pricing_options: [],
        selected_pricing_options: [],
        local: {
          dow: 1,
          hourTip: '',
          minuteTip: '',
          secondTip: '',
          yearSuffix: '',
          monthsHead: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
          months: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
          weeks: 'Mon_Tue_Wed_Thu_Fri_Sat_Sun'.split('_'),
        },
      };
    },
    components: {
      Multiselect,
      VueDatepickerLocal,
    },
    created() {
      this.fetchPricingOptions();

      if (this.editedRule) {
        this.edit_state = true;
        this.timeframe = this.editedRule.timeframe;
      }
    },
    methods: {
      fetchPricingOptions() {
        api.getPricingOptions().then((response) => {
          this.pricing_options = response.pricing_options;
        }).catch((err) => {
          this.$toasted.error(err.message);
        });
      },
      fetchServiceCategories() {
        api.getServiceCategories().then((response) => {
          this.service_categories = response.service_categories;
        }).catch((err) => {
          this.$toasted.error(err.message);
        });
      },
      fetchRevenueCategories() {
        api.getRevenueCategories().then((response) => {
          this.revenue_categories = response.revenue_categories;
        }).catch((err) => {
          this.$toasted.error(err.message);
        });
      },
      commitCondition() {
        const payload = {
          condition: {
            uuid: this.condition.uuid,
            name: this.condition.name,
            unique: this.condition.unique,
          },
          purchase_activated: this.purchase_activated,
          purchase_type: this.purchase_type,
          pricing_options: this.selected_pricing_options,
          timeframe: this.timeframe,
          relative_days: this.relative_days,
          comparison: this.comparison ? this.comparison.value : null,
          start_date: this.dates.start,
          end_date: this.dates.end,
          misc: {
            filtering: this.misc_filtering,
            location: this.location ? this.location.location_id : null,
            site_id: null,
          },
        };

        EventBus.$emit('conditions_selection.commit', payload);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .sidebar-inner {
    position: relative;
  }

  .sidebar-inner .condition-banner {
    margin-top: 2rem;
    background-color: #f2f6fa;
    font-size: .75rem;
    font-weight: 700;
    line-height: 1rem;
    margin-bottom: 1.5rem;
    padding-top: .5rem;
    padding-bottom: .5rem;
    padding-left: 1.5rem;
    color: #8b9bac;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    text-transform: uppercase;
  }

  .sidebar-inner .condition-banner:first-child {
    margin-top: 0;
  }

  .multiselect {
    width: auto !important;
    display: inline-block !important;
  }

  .multiselect-block .multiselect {
    width: 100% !important;
    display: block !important;
  }

  .form-group {
    margin-top: 1.5rem;
    width: 100%;
  }

  .dates {
    display: flex;
    align-items: center;
  }

  .dates span {
    margin-right: .5rem;
    margin-left: .5rem;
  }

  button {
    margin-top: 1rem;
  }

  .see-more {
    cursor: pointer;
  }

  .icon-radio-checked,
  .icon-radio-unchecked {
    margin-right: 1rem;
  }

  .row {
    margin-right: 0;
    margin-left: 0;
    flex-wrap: nowrap;
  }

  .options-inner {
    margin-left: 2rem;
    border-radius: 6px;
    background-color: #f2f6fa;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: .875rem;
    line-height: 1.25rem;
    color: #1d364b;
  }

  .options-inner .form-group:first-child {
    margin-top: 0;
  }

  .options-inner .form-group:last-child {
    margin-bottom: 0;
  }

  .footer {
    position: fixed;
    display: flex;
    align-items: center;
    bottom: 0;
    width: 100%;
    border-top: 1px solid var(--xpl-color-gray-400);
    padding-top: .75rem;
    padding-bottom: .75rem;
    padding-left: 1.5rem;
    background-color: white;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    z-index: 1001;
  }

  .footer button {
    margin: 0;
  }
</style>
